import { render, staticRenderFns } from "./FrequentlyAskedQuestions.vue?vue&type=template&id=24878276&scoped=true&"
import script from "./FrequentlyAskedQuestions.vue?vue&type=script&lang=js&"
export * from "./FrequentlyAskedQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24878276",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24878276')) {
      api.createRecord('24878276', component.options)
    } else {
      api.reload('24878276', component.options)
    }
    module.hot.accept("./FrequentlyAskedQuestions.vue?vue&type=template&id=24878276&scoped=true&", function () {
      api.rerender('24878276', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/Account/Children/FAQ/FrequentlyAskedQuestions.vue"
export default component.exports